import styled from 'styled-components'
import PhoneIcon from '@mui/icons-material/Phone';
import EmailIcon from '@mui/icons-material/Email';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import FavoriteIcon from '@mui/icons-material/Favorite';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import GitHubIcon from '@mui/icons-material/GitHub';

const ContactUs = () => {
    return (
        <>
            <h1 style={{ color: "#32AFE5", textTransform: "uppercase" }}>my contacts</h1>
            <Container id='contact'>
                <div className='contactSection'>
                    <h3><PhoneIcon />  (+91) 8436510374</h3>
                    <h3><EmailIcon /> arnabpal679@gmail.com</h3>
                    <h3> <LocationOnIcon /> Durgapur, West Bengal, India</h3>
                </div>
                <div>
                    <a href='https://www.linkedin.com/in/arnab-pal-71248b155/'><button className='socialLink'><LinkedInIcon fontSize="large" sx={{ color: '#0A66C2' }} /></button></a>
                    <a href='https://github.com/arnab9593'><button className='socialLink'><GitHubIcon fontSize="large" sx={{ color: 'black' }} /></button></a>
                </div>

                <div className='endSection'>
                    <p> Designed by Arnab Pal with <FavoriteIcon sx={{ color: 'red' }} /></p>
                </div>
            </Container>
        </>
    )
}
const Container = styled.div`
    width:100%;
    background-color:white;
    .contact{
        width:85%;
        margin:auto;
        padding-top:20px;
        flex-direction:column;
        gap:30px; 
        
    }
    border: 1px solid #e9e9e9;
    border-radius:10px 10px 10px 10px;
    box-shadow: rgba(0, 0, 0, 0.15) 0px 5px 15px 0px;

   

    .endSection{
        display:flex;
        align-items:center;
        justify-content:center;
        height:70px;
        background-color:black;
        color:white;
        margin-top:20px;
    }
    .endSection>p{
        display:flex;
        align-items:center;
        justify-content:center;
        gap:5px;
    }

    .contactSection>h3{
        display:flex;
        align-items:center;
        justify-content:center;
        gap:5px;
        font-weight: normal;
    }

    .socialLink{
        background-color:transparent;
        color: White;
        padding:8px 20px 8px 20px;
        border-radius:8px;
        font-weight:bold;
        align-items:center;
        justify-content:center;
        gap:10px;
        border:none;
        cursor:pointer;
    }

    .socialLink:hover{
        -webkit-transform: translateY(-2px);
        transform: translateY(-2px);
        -webkit-transition: all 0.5s;
        transition: all 0.5s;
    }

`
export default ContactUs